import { DextNumberInputWUT } from '@wix/form-fields/wut';

export default DextNumberInputWUT;
